import React from "react"

import {ExpandLess, ExpandMore, KeyboardArrowDown, StarBorder} from "@mui/icons-material"
import {Button, Menu} from "@mui/material"
import Collapse from "@mui/material/Collapse"
import Fab from "@mui/material/Fab"
import List from "@mui/material/List"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"

import {DropDownItems, DropDownMenuProps} from "../../utils/@types/DropdownInterface"

function DropDownMenu(props: DropDownMenuProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

    const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const [open, setOpen] = React.useState<string>("")

    const handleClick = (clickFunction: any) => {
        setAnchorEl(null)
        clickFunction()
    }

    const handleClose = (lang: string) => {
        setAnchorEl(null)
    }

    function renderMenuClass() {
        return `${props.topCard ? "topCard" : ""}${props.bottomCard ? " bottomCard" : ""}`
    }

    /*
	  genereate the right button
	*/
    const Buttontype = props.isClassic ? (
        <Button
            variant="contained"
            color="primary"
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleMenuClick}
        >
            {props.button}
            <KeyboardArrowDown />
        </Button>
    ) : props.isFab ? (
        <Fab
            color="primary"
            variant="extended"
            onClick={handleMenuClick}
            style={{display: "flex", justifyContent: "space-between"}}
        >
            {props.button}
        </Fab>
    ) : (
        <span style={{cursor: props.disabled ? "not-allowed" : "pointer"}}>
            <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                disabled={props.disabled}
                onClick={handleMenuClick}
                style={{fontSize: 14}}
            >
                {props.button}
            </Button>
        </span>
    )

    return (
        <React.Fragment>
            {props.items.length > 1 && props.button !== "" && (
                <>
                    {Buttontype}

                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        className={renderMenuClass()}
                        MenuListProps={{
                            "aria-labelledby": "simple-button"
                        }}
                        // anchorOrigin={{
                        //   vertical: "bottom",
                        //   horizontal: "right"
                        // }}
                        transformOrigin={{
                            vertical: "bottom",
                            horizontal: "center"
                        }}
                    >
                        <List
                            sx={{width: 280, maxWidth: 280, bgcolor: "white"}}
                            subheader={props.topCard !== undefined ? props.topCard : null}
                        >
                            {props.items.map((item: DropDownItems, index: number) => (
                                <React.Fragment key={"main_" + index}>
                                    <ListItemButton
                                        onClick={() => {
                                            if (item.subItem) {
                                                setOpen((c) => (c === item.key ? "" : item.key))
                                            } else {
                                                if (item.click) {
                                                    handleClick(item.click)
                                                }
                                            }
                                        }}
                                    >
                                        <ListItemIcon>{item.icon}</ListItemIcon>
                                        <ListItemText primary={item.text} />

                                        {!item.subItem ? null : open === item.key ? <ExpandLess /> : <ExpandMore />}
                                    </ListItemButton>

                                    {item.subItem && (
                                        <Collapse in={open === item.key} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {item.subItem.map((itemSub: any, index: number) => (
                                                    <ListItemButton
                                                        sx={{pl: 4}}
                                                        key={"Sub" + index}
                                                        onClick={() => handleClick(itemSub.click)}
                                                    >
                                                        <ListItemIcon>
                                                            {itemSub.icon ? itemSub.icon : <StarBorder />}
                                                        </ListItemIcon>
                                                        <ListItemText primary={itemSub.text} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    )}
                                </React.Fragment>
                            ))}
                        </List>
                        <div>{props.bottomCard !== undefined ? props.bottomCard : null}</div>
                    </Menu>
                </>
            )}
            {props.items.length === 1 && props.button === "" && (
                <Button
                    variant="contained"
                    color="primary"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => props.items[0].click()}
                    className="TableAddBtn"
                >
                    {props.items[0].text}
                </Button>
            )}
        </React.Fragment>
    )
}

export default DropDownMenu
